var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-skeleton", {
                attrs: { animation: "fade", height: "1rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("b-skeleton", {
                attrs: { animation: "fade", height: "1rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("b-skeleton", {
                attrs: { animation: "fade", height: "1rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("b-skeleton", {
                attrs: { animation: "fade", height: "1rem" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }